<div class="card step-card flex flex-column">

  <div class="grid">
    <div class="col-12">
      <p>{{'misc.roleChange.noAccess' | transloco}}</p>
      <div
        [pDroppable]="['superadmin', 'admin', 'viewer', 'operator']"
        (onDrop)="drop(available)"
        class="grid border-1 draggable-container py-3 px-3"
      >
        <div
          *ngFor="let app of available"
          (onDragStart)="dragStart(app)"
          (onDragEnd)="dragEnd()"
          (touchstart)="touchStart(app, availableMenu, $event)"
          class="flex align-items-center py-2 px-2 draggable-item col-12 md:col-4 xl:col-3"
          pDraggable="available"
        >
          <i class="pi pi-desktop mr-2"></i>
          <p>{{app.label}}</p>
        </div>
      </div>
      <p-menu #availableMenu [popup]="true" [model]="contextMenuAvailable" [style]="{ width:'250px' }"></p-menu>
    </div>
    <div [ngClass]="{'col-12': true, 'md:col-6': true, 'xl:col-3' : 'ROLE_SUPER_ADMIN' | userHasRole, 'xl:col-4' : !('ROLE_SUPER_ADMIN' | userHasRole)}">
      <p>{{'role.viewer' | transloco}}</p>
      <div
        [pDroppable]="['available', 'superadmin', 'admin', 'operator']"
        (onDrop)="drop(viewer)"
        class="flex flex-column border-1 draggable-container py-3 px-3"
      >
        <div
          *ngFor="let app of viewer"
          (onDragStart)="dragStart(app)"
          (onDragEnd)="dragEnd()"
          (touchstart)="touchStart(app, viewerMenu, $event)"
          class="flex align-items-center py-2 px-2 draggable-item"
          pDraggable="viewer"
        >
          <i class="pi pi-desktop mr-2"></i>
          <p>{{app.label}}</p>
        </div>
      </div>
      <p-menu #viewerMenu [popup]="true" [model]="contextMenuViewer" [style]="{ width:'250px' }"></p-menu>
    </div>

    <div [ngClass]="{'col-12': true, 'md:col-6': true, 'xl:col-3' : 'ROLE_SUPER_ADMIN' | userHasRole, 'xl:col-4' : !('ROLE_SUPER_ADMIN' | userHasRole)}">
      <p>{{'role.operator' | transloco}}</p>
      <div
        [pDroppable]="['superadmin', 'admin', 'viewer', 'available']"
        (onDrop)="drop(operator)"
        class="flex flex-column border-1 draggable-container py-3 px-3"
      >
        <div
          *ngFor="let app of operator"
          (onDragStart)="dragStart(app)"
          (onDragEnd)="dragEnd()"
          (touchstart)="touchStart(app, operatorMenu, $event)"
          class="flex align-items-center py-2 px-2 draggable-item"
          pDraggable="operator"
        >
          <i class="pi pi-desktop mr-2"></i>
          <p>{{app.label}}</p>
        </div>
      </div>
      <p-menu #operatorMenu [popup]="true" [model]="contextMenuOperator" [style]="{ width:'250px' }"></p-menu>
    </div>

    <div [ngClass]="{'col-12': true, 'md:col-6': true, 'xl:col-3' : 'ROLE_SUPER_ADMIN' | userHasRole, 'xl:col-4' : !('ROLE_SUPER_ADMIN' | userHasRole)}">
      <p>{{'role.admin' | transloco}}</p>
      <div
        [pDroppable]="['available', 'superadmin', 'viewer', 'operator']"
        (onDrop)="drop(admin)"
        class="flex flex-column border-1 draggable-container py-3 px-3"
      >
        <div
          *ngFor="let app of admin"
          (onDragStart)="dragStart(app)"
          (onDragEnd)="dragEnd()"
          (touchstart)="touchStart(app, adminMenu, $event)"
          class="flex align-items-center py-2 px-2 draggable-item"
          pDraggable="admin"
        >
          <i class="pi pi-desktop mr-2"></i>
          <p>{{app.label}}</p>
        </div>
      </div>
      <p-menu #adminMenu [popup]="true" [model]="contextMenuAdmin" [style]="{ width:'250px' }"></p-menu>
    </div>

    <div class="col-12 md:col-6 xl:col-3" *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
      <p>{{'role.superAdmin' | transloco}}</p>
      <div
        [pDroppable]="['available', 'admin', 'viewer', 'operator']"
        (onDrop)="drop(superadmin)"
        class="flex flex-column border-1 draggable-container py-3 px-3"
      >
        <div
          *ngFor="let app of superadmin"
          (onDragStart)="dragStart(app)"
          (onDragEnd)="dragEnd()"
          (touchstart)="touchStart(app, superadminMenu, $event)"
          class="flex align-items-center py-2 px-2 draggable-item"
          pDraggable="superadmin"
        >
          <i class="pi pi-desktop mr-2"></i>
          <p>{{app.label}}</p>
        </div>
      </div>
      <p-menu #superadminMenu [popup]="true" [model]="contextMenuSuperadmin" [style]="{ width:'250px' }"></p-menu>
    </div>

  </div>

  <div class="mt-4 sm:mt-auto">
    <div class="flex flex-column sm:flex-row justify-content-between">
      <div class="flex justify-content-between sm:justify-content-start sm:flex-order-1">
        <button
          [label]="'common.previous' | transloco"
          (click)="onPreviousStep()"
          pButton
          pRipple
          class="flex-1 sm:flex-none"
          icon="pi pi-angle-left"
          iconPos="left"
        ></button>
        <button
          [label]="'common.next' | transloco"
          (click)="onNextStep()"
          pButton
          pRipple
          class="ml-2 flex-1 sm:flex-none"
          icon="pi pi-angle-right"
          iconPos="right"
        ></button>
      </div>
      <button
        [label]="'common.cancel' | transloco"
        [routerLink]="'/management/users'"
        pButton
        pRipple
        class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
      ></button>
    </div>
  </div>

</div>
